import { render, staticRenderFns } from "./IrStatementsInvoicesViewer.vue?vue&type=template&id=7acf6ccf&"
import script from "./IrStatementsInvoicesViewer.vue?vue&type=script&lang=js&"
export * from "./IrStatementsInvoicesViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports